import type { GetConsumerRewardsCampaignsOrPrizesResponse } from "@jti/evo-client";
import type {
  GetPrizesElementResponseType,
  GetPrizesResponseType,
  RewardFilterType,
  RewardType,
} from "@jti/rest-api-types";

export const convertRewardFilterToEvoRewardType = (filterType?: RewardFilterType): RewardType | undefined => {
  if (filterType === "virtual" || filterType === "sensorial") {
    return "simplified";
  }
  if (filterType === "physical") {
    return "physical";
  }
};

export const convertEvoGetPrizes = (evoPrizes: GetConsumerRewardsCampaignsOrPrizesResponse): GetPrizesResponseType => {
  const { data, meta } = evoPrizes;

  const convertedPrizes: Array<GetPrizesElementResponseType> = data.map((prize) => {
    const {
      presentation: { images = [], name, description },
      identifier: prize_uuid,
      brand_name: brandName,
      points,
      custom_attributes: { color, locations = [], slug },
      has_coupons,
      created_at,
      levels,
      usage_limit: { per_user } = {},
      redeemed_times,
      prize_type,
      validity_rules = {
        time: { to: undefined, from: undefined, limited: false },
      },
    } = prize;

    return {
      prize_uuid,
      name,
      brandName,
      subtitle: description ?? "",
      points,
      images,
      color: color ?? "",
      has_coupons,
      created_at,
      levels: levels ?? [],
      locations,
      slug,
      isAddressRequired: Boolean(prize?.custom_attributes?.is_address_required),
      prize_type,
      redeemedTimes: redeemed_times,
      usageLimit: per_user,
      time_to: validity_rules?.time?.to ?? undefined,
      time_from: validity_rules?.time?.from ?? undefined,
    };
  });

  return {
    items: convertedPrizes,
    total: meta.total ?? 0,
  };
};
